<template>
  <Page bg_color="bg-white">
    <v-img
      cover
      :src="login_bg_url"
      gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
    >
      <!-- https://www.vuescript.com/vue-js-component-particles-backgrounds/ -->
      <vue-particles
        color="#dedede"
        :particleOpacity="0.7"
        :particlesNumber="80"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
        class="particles-bg-js"
      >
      </vue-particles>
      <CenterPageColumn :outlined="false" :has_nav_bar="true">
        <CenterNavbar
          :crumps="[]"
          title=""
          :width_class="page_info.center_width_class"
          bg_color=""
        ></CenterNavbar>
        <ContactPageBanner
          bg_url=""
          :has_nav_bar="true"
          id="login_form_top"
          logo_class="logo-bg2"
        ></ContactPageBanner>
        
        <CardedForm
          style="max-width: 600px; margin: auto !important"
          ref="carded_login_form_ref"
          id="login_form"
          title="Login To Access Your Account"
          :is_loading="is_loading"
          @on-submit-form="on_login"
          :errors="errors"
          :message="message"
          @on-auto-fill="on_auto_fill"
        >
          <TextField
            v-model="email"
            :validation_rules="email_rules"
            label="E-mail Address/ Phone Number"
            icon="mdi-email-variant"
            :disabled="is_loading"
          ></TextField>

          <TextField
            v-model="password"
            :validation_rules="password_rules"
            label="Password"
            icon="mdi-key-variant"
             type="password"
            :disabled="is_loading"
          ></TextField>
          <template v-slot:clearbtnslot>
            <v-btn
              class="ma-0"
              to="/forgot_password"
              dense
              text
             
              color="success"
              :disabled="is_loading"
            >
              Forgot password ?
            </v-btn>
          </template>
          <template v-slot:lower>
            <div class="text-muted mt-5">-- OR --</div>
            <v-divider></v-divider>
            <v-row class="mb-5">
              <v-col cols="12 mt-0 mb-1 pb-0 pt-2 text-left">
                <v-btn
                  class="ma-0 mb-2"
                  to="/forgot_password"
                  dense
                  text
                  color="success"
                  :disabled="is_loading"
                >
                  Create an account/ Sign up
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </CardedForm>
      </CenterPageColumn>
    </v-img>

    <v-row class="ma-0 pa-0 bg-footer" no-gutters>
      <v-col cols="2" class="ma-0 pa-0 wrapper-bg" no-gutters></v-col>
      <v-col class="ma-0 pl-0 bg-footer" no-gutters>
        <Footer
          :is_loading="is_loading"
          @on-hide-loader="$emit('on-hide-loader')"
          @on-show-loader="$emit('on-show-loader')"
        ></Footer>
      </v-col>
      <v-col cols="2" class="ma-0 pa-0 wrapper-bg" no-gutters></v-col>
    </v-row>
  </Page>
</template>


<script>
import Page from "./../../components/Page";

import CenterPageColumn from "./../../components/CenterPageColumn";
import CenterNavbar from "./../../components/CenterNavbar";
import ContactPageBanner from "./../../components/ContactPageBanner";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import CardedForm from "./../../components/CardedForm";
import TextField from "./../../components/TextField";
import RedText from "./../../components/RedText";
import Footer from "./../../components/CenterFooter";

import page_info from "./../../lib/page_info";
import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";

export default {
  name: "Login",
  components: {
    Page,
    CenterPageColumn,
    CenterNavbar,
    ContactPageBanner,
    CardedForm,
    TextField,
    RedText,
    Footer,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: "login",
    login_bg_url:
      "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1602788555/botswana%20services/website%20assets/login_bg_qmbfxp.png",
    errors: [],
    message: "",
    email: "",
    email_rules: [
      Utils.validate.is_required("Email address or Phone number is required"),
      Utils.validate.email_format_or_phone(
        "Invalid input, must be a valid email address or a valid phone number"
      ),
    ],
    password: "",
    password_rules: [
      Utils.validate.is_required("Password is required"),
      Utils.validate.max_length(
        15,
        "Password should be less than 16 characters long"
      ),
    ],
    page_info: page_info,
    prevRoute: null,
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  mounted() {
    //https://stackoverflow.com/questions/54770883/how-to-navigate-to-different-section-in-the-same-page-using-vuetify
    var options = {
      offset: 102,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#login_form_top", options);
  },
  methods: {
    on_auto_fill() {
      this.email = "+256779488038";
      this.password = "qwerty2015";
    },
    on_assign_email_and_phone_number(values) {
      this[values.prop] = values.value;
    },
    on_assign_first_name_and_last_name(values) {
      this[values.prop] = values.value;
    },
    on_login() {
      //form is already validated
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Login.login(
        {
          email: this.email,
          password: this.password,
        },
        (res) => {
          // console.log("login ", res);
          this.$refs.carded_login_form_ref.on_clear_form();
          // this.$refs.carded_login_form_ref.show_message_dialog();
          this.$emit("on-hide-loader");
          if(this.prevRoute && this.prevRoute.path == "/activate"){
            //must be coming from a signup
            //so we go back to where we started from
            var path = localStorage.getItem("before_singup_route");
            this.$router.push(path);
            return;
          }

          var user = ServerClient.Login.get_logged_in_user();
          this.$emit('set-user',user);
          var is_admin = Utils.is_admin(user);
          if(is_admin){
            this.$router.push("/admin/dashboard");
          }else{
            this.$router.push("/owner/dashboard");
          }
          
        },
        (errors) => {
          // console.log("errors ", errors);
          this.errors = errors;
          this.$refs.carded_login_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
  },
};
</script>

